import { render, staticRenderFns } from "./profile-phone-login.vue?vue&type=template&id=c038de00&scoped=true&"
import script from "./profile-phone-login.vue?vue&type=script&lang=js&"
export * from "./profile-phone-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c038de00",
  null
  
)

export default component.exports